import React from 'react';
import Axios from 'axios';
import { CSVLink, CSVDownload } from "react-csv";

// react-csv procedure
/*
const csvData = [
  ["firstname", "lastname", "email"],
  ["Ahmed", "Tomi", "ah@smthing.co.com"],
  ["Raed", "Labes", "rl@smthing.co.com"],
  ["Yezzi", "Min l3b", "ymin@cocococo.com"]
];
LINK:  <CSVLink data={csvData}>Download me</CSVLink>
ACTION:  <CSVDownload data={csvData} target="_blank" />
*/

const cstTableHeaders = [
	'Joueur', 'Inscriptions', 'Paiements', 'Bourses', 'Versements', 'Transferts', 'Solde'];

const cstDefaultSortOrder = [
	'asc', 'desc', 'desc', 'desc', 'desc', 'desc', 'desc'];

const cstDefaultSortFieldIdx = 0;


class QvneaBooksSummary extends React.Component {

  constructor(props) {
		super(props);
		this.state = {
			dataTable: [],
			sortFieldIdx: cstDefaultSortFieldIdx,
			sortOrder: cstDefaultSortOrder[cstDefaultSortFieldIdx],
			csvTableData: [],
			loading: true,
		};

		this.createDataTable = this.createDataTable.bind(this);
		this.sortdataTable = this.sortdataTable.bind(this);
		this.createTableHdrRow = this.createTableHdrRow.bind(this);
		this.createDataRow = this.createDataRow.bind(this);
		this.createDataCell = this.createDataCell.bind(this);
		this.handleSortTable = this.handleSortTable.bind(this);
	}

 	componentDidMount() {
		// console.log('QvneaBooksSummary: componentDidMount');
		this.loadPlayersBalance();
	}

	UNSAFE_componentWillReceiveProps(nextProps) {
		// console.log('QvneaBooksSummary: UNSAFE_componentWillReceiveProps: ');
		// console.log(nextProps);
		// this.loadPlayersBalance(n);
	}

  loadPlayersBalance() {
		// season is empty on first renders when refreshing page (due to league change first with no season)
    var _this = this;

    Axios.get('/api/qvneaBooks/playersSummary').then(function (response) {
    	// console.log(response.data)
    	
    	// dummy
    	_this.createDataTable(response.data);
		});

  }

	createDataTable(dataResults) {

		var dataTable = [];
		dataResults.forEach(function(result, resultIdx) {

			var dataTableRow = [];
			// dataTableRow.push(0);		// rank
			//dataTableRow.push(result.playerId);
			dataTableRow.push(result.fullname);
			dataTableRow.push(result.qb.inscription);
			dataTableRow.push(result.qb.paiement);
			dataTableRow.push(result.qb.bourse);
			dataTableRow.push(result.qb.versement);
			dataTableRow.push(result.qb.transfert);
			dataTableRow.push(result.qb.balance);

			// Build table
			dataTable.push(dataTableRow.slice());
		});

		// First data sort
		this.sortdataTable(dataTable, this.state.sortFieldIdx, this.state.sortOrder);

		// CSV Data: copy tableData and add headers
		var csvTableData = [...dataTable];
		csvTableData.unshift(cstTableHeaders);
		this.setState({
			csvTableData: csvTableData
		});
	}

	sortdataTable(dataTable, sortFieldIdx, sortOrder) {

		// Manage empty data
		if (dataTable.length !== 0) {

			var sortSign = 1;
			if (sortOrder === 'desc') { 
				sortSign = -1; 
			}

			dataTable.sort(function(a, b) {
				var valueA = a[sortFieldIdx];
				var valueB = b[sortFieldIdx];
				var compVal = 0;

				switch(typeof a[sortFieldIdx]) {
			    case "date":
						compVal = new Date(valueA) - new Date(valueB);
		        break;
			    case "string":
						compVal = valueA.localeCompare(valueB);
		        break;
			    case "number":
						compVal = valueA - valueB;
		        break;
			    default:
		        break;
				}

				if (compVal !== 0) {
					return (sortSign * compVal);
				} else {
					return a[0].localeCompare(b[0]);
				}
			});
		}

		this.setState({
			dataTable: dataTable,
			sortFieldIdx: sortFieldIdx,
			sortOrder: sortOrder,
			loading: false,
		});
	}

	render() {
		//console.log('QvneaBooksSummary: render');
		//console.log(this.state);

		return (
			<div className="animated fadeIn">
        <div className="row row-margin-bottom-10">
        <div className="col-12">
          <h4>QVNEA Books - Sommaire des joueurs</h4>
				</div>
				</div>

				{(this.state.loading) ?
					this.displaySpinner() : 
					//this.displayModule(pager)

	        <div>
	        <div className="row">
	        <div className="col-12 text-right">
						<CSVLink
						  data={this.state.csvTableData}
						  filename={"qvnea-books-summary.csv"}
						  className="btn btn-sm btn-primary"
						  target="_blank"> <i className="fa fa-download"></i> Télécharger le sommaire
						</CSVLink>
					</div>
					</div>

	      	<div className="row">
	      	<div className="col-md-12">
						<div className="table-responsive">
						<table className="table table-hover table-sm">
						<thead>
							<tr>
							{cstTableHeaders.map(this.createTableHdrRow)}
							</tr>
						</thead>

						{this.displayTable()}
						</table>
						</div>

					</div>
					</div>
					</div>
				}

      </div>
		);
	}

	createTableHdrRow(hdrItem, hdrIdx) {

		// ID Visible only in master mode
		var classNameStr = '';
		var onClickAction = function() {};

		var sortFieldIdx = this.state.sortFieldIdx;
		var sortOrder = this.state.sortOrder;
		onClickAction = this.handleSortTable;

		// Sort with arrows
		classNameStr = 'statelo-sorting';
		if(hdrIdx === sortFieldIdx) {
			if (sortOrder === "asc") {
				classNameStr += ' statelo-sorting_asc';
			} else {
				classNameStr += ' statelo-sorting_desc';
			}
		}

		var colWidth = "auto";
		if (hdrIdx >= 1) {
			//colWidth = "80px";
			classNameStr += " text-right";
		}

		return (
			<th key={"colid." + hdrIdx}
				id={"colid." + hdrIdx} 
				className={classNameStr}
				onClick={onClickAction}
				width={colWidth}>
				{hdrItem}
			</th>
		);
	}


	displayTable() {
		if (this.state.dataTable.length === 0) {
			return (
				<tbody>
					<tr><td colSpan="99">Aucun joueur</td></tr>
				</tbody>
			)
		} else {
			return (
				<tbody>
					{this.state.dataTable.map(this.createDataRow)}
				</tbody>			
			)
		}
	}

  createDataRow(dataRow, dataRowIdx) {
		return (
			<tr key={'te.' + dataRowIdx}>
				{dataRow.map(this.createDataCell)}
      </tr>
    );
  }

 	createDataCell(dataCell, dataCellIdx) {

 		var classNameStr = "";
 		if (dataCellIdx === 6) {
 			classNameStr = "font-weight-bold";
 		}

 		if (dataCellIdx > 0) {
 			dataCell = dataCell.toFixed(2) + ' $';
 			classNameStr += " text-right";
 		}

		return (
			<td className={classNameStr} key={"tdcell." + dataCellIdx}>{dataCell}</td>
		);
	}

	handleSortTable(e) {
		var _this = this;
		var sortFieldIdx = parseInt(e.target.id.split(".")[1], 10);

		var dataTable = this.state.dataTable;
		var sortOrder = this.state.sortOrder;
		var prevSortFieldIdx = this.state.sortFieldIdx;

		// Toggle sort order
		if (prevSortFieldIdx === sortFieldIdx) {
			if (sortOrder === 'asc') {
				sortOrder = 'desc';
			} else {
				sortOrder = 'asc';
			}
		} else {
			sortOrder = cstDefaultSortOrder[sortFieldIdx];
		}

		this.sortdataTable(dataTable, sortFieldIdx, sortOrder);
	}

	displaySpinner() {
		return (
  		<div className="sk-three-bounce">
    		<div className="sk-child sk-bounce1"></div>
    		<div className="sk-child sk-bounce2"></div>
    		<div className="sk-child sk-bounce3"></div>
  		</div>
  	);
	}

}

export default QvneaBooksSummary;
